import type { FaireProductEntity } from "../../entity_types/product";

export const p_a68drrc1: FaireProductEntity = {
  token: "p_a68drrc1",
  type: "product",
  name: "OAKMOSS CANDLE",
  brandToken: "b_bsf417rw",
  brandName: "Ranger Station Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/fc69cf27586ab5528b7cca7adb30edb98c410c9372bd883514bc5a42d00555c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f68a4bb1ba1c8d32f366054ef4c1f6eb846f9cf53641593670aaa6996c8ba602.jpeg",
    "https://cdn.faire.com/fastly/c5b088fd63f56338880a037a7abd4cf65cf668571b3f8510fe4670d85496491c.jpeg",
  ],
  priceDollars: 19.5,
  description:
    "Smells like: moss / cedarwood / amber / bergamot \n\nWith notes of spring water, green grass, and charred sage, this scent is evocative of the moment just after a lightning storm, when the sky abruptly clears and the sun beams down onto the freshly damp earth. One of the most common raw materials used in perfumery, Oakmoss is laid bare in this fragrance, stripped to its purest form then stacked with red amber, bergamot, and sandalwood for a warm, forest-floor base and then elevated by the botanical brightness of lavender and violet leaf.\n\n8 oz. premium soy wax blend\nHand-poured & packaged in Nashville, TN\nMatchbox included with every Ranger Station Candle\n40+ hour burn time\nEach candle comes with a perfectly paired cocktail recipe to enjoy once the candle is burned through\n\nMatches, Candle, Western, Unisex, Gifts, Giftable Candle jars, Gifts Under $40, Gifts for the Host, Small-Batch Favorites, Father's Day, Spring, Summer 2026, Spring 2026, Summer, Book Club, Ritual Aids, picnic, patio, Fourth of July, 4th of July, Americana",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:13.561Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
